import type {
  ReferenceMatchResult,
  ReferenceMatchStatus,
} from 'contracts/HoraCertaImport';

export const selectionKey = (entityType: string, normalizedValue: string) =>
  `${entityType}::${normalizedValue}`;

export const isUnresolved = (match: ReferenceMatchResult) =>
  match.status === 'pending' || match.status === 'invalid_mapping';

export const statusLabel = (status: ReferenceMatchStatus) => {
  if (status === 'mapped' || status === 'exact') return 'Mapeado';
  if (status === 'invalid_mapping') return 'Não encontrado';
  return 'Pendente';
};

export const statusClassName = (status: ReferenceMatchStatus) => {
  if (status === 'mapped' || status === 'exact')
    return 'bg-emerald-50 text-emerald-600';
  if (status === 'invalid_mapping') return 'bg-red-50 text-red-600';
  return 'bg-amber-50 text-amber-600';
};

export const getErrorMessage = (error: any): string => {
  const response = error?.response;
  if (response?.status >= 500) {
    return 'Ocorreu um erro interno. Tente novamente mais tarde.';
  }
  return (
    response?.data?.message ||
    error?.message ||
    'Não foi possível concluir a operação.'
  );
};

export const getErrorDetails = (
  error: any
): Array<{ field: string; message: string }> => {
  const details = error?.response?.data?.details;
  return Array.isArray(details) ? details : [];
};

export const resolveDetailKey = (
  field: string,
  orderedMatches: ReferenceMatchResult[]
): string | undefined => {
  if (field.startsWith('references.')) {
    const [, entityType, normalizedValue] = field.split('.');
    if (entityType && normalizedValue)
      return selectionKey(entityType, normalizedValue);
    return undefined;
  }
  if (field.startsWith('mappings.')) {
    const match = orderedMatches[Number(field.split('.')[1])];
    return match
      ? selectionKey(match.entityType, match.normalizedValue)
      : undefined;
  }
  const fallback = orderedMatches[0];
  return fallback
    ? selectionKey(fallback.entityType, fallback.normalizedValue)
    : undefined;
};
